import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_3717c142 from '../styles/Link.module.less.js';

/**
 * @description The Link component is used for anchor links. This component renders a a element by default
 *
 * @component
 * @example
 * ```jsx
 * <Link href="#">Link</Link>
 * ```
 */
const Link = React.forwardRef((props, ref) => {
    const { color, strong, className, children, ...restProps } = props;
    const cx = useStyles(modules_3717c142);
    const classNames = cx(className, 'container', {
        [`color-${color}`]: color,
        strong,
    });
    return (React.createElement("a", { ref: ref, className: classNames, ...restProps }, children));
});
Link.defaultProps = {
    color: 'blue',
};
Link.displayName = 'Link';

export { Link };
//# sourceMappingURL=Link.js.map
